import {API_URL} from "../../constants";
import {SessionModal} from "./SessionModal";
import {connect} from 'react-redux'
import {addSession} from "../../redux/actions";

class AddSessionModal extends SessionModal {
    handleClose() {
        this.setState((state, props) => ({
            selectedSessionType: this.props.selectedSessionType === 'Paper' ? this.props.selectedSessionType : '',
            newSession: this.props.selectedSessionType === 'Paper' ? {panel_color: '#d9edf7'} : {},
            alertShow: false,
            alertMessage: ''
        }));

        // Call to parent's callback
        this.props.handleClose();
    }

    handleSave() {
        const data = {
            type: this.state.selectedSessionType,
            data: this.state.newSession
        };

        fetch(API_URL + '/sessions', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + this.props.user.api_token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);    // Will go to .catch
                return response.json();
            })
            .then((data) => {
                /* If session has been created correctly then dispatch an action that will
                add a session to the current list of sessions */
                this.props.addSession(data);

                this.props.onSessionSaved(data);

                /* Close modal window */
                this.handleClose();
            })
            .catch((error) => {
                this.showAlert(error.toString());
            })
    }
}

export default connect(
    null,
    {addSession}
)(AddSessionModal);
